import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
// import "./addQuestion.css";
import CustomButton from "../../../components/button";

// Static difficulty levels (no import from constants)
const difficultyLevel = [
    { label: "Easy (Beginner)", value: "easy" },
    { label: "Medium (Limited Experience)", value: "medium" },
    { label: "Hard (Experienced)", value: "hard" },
];

const QuestionOpt = (props) => {

    const { handleNext, details, handleChange } = props

    const [valiteded, setValiteded] = useState(false);
    const [level, setLevel] = useState("Medium (Limited Experience)");
    const [numQuestions, setNumQuestions] = useState(12);

    const MIN = 3;
    const MAX = 24;
    const [thumbLeft, setThumbLeft] = useState(0);
    const rangeRef = useRef(null);

    useEffect(() => {
        if (rangeRef.current) {
            const rangeWidth = rangeRef.current.offsetWidth;
            const percent = (details?.noOfQuestion - MIN) / (MAX - MIN);
            const newLeft = percent * rangeWidth;
            setThumbLeft(newLeft);

            const percentWidth = ((details?.noOfQuestion - MIN) / (MAX - MIN)) * 100;
            rangeRef.current
                .querySelector("input")
                .style.setProperty("--fill", `${percentWidth}%`);
        }
    }, [details?.noOfQuestion]);

    const handleSliderChange = (e) => {

        setNumQuestions(Number(e.target.value));
    };

    return (
        <div style={{ backgroundColor: "#F2F4F7" }} className="canLisContentWrap">
            <div className="t-wrapper-div">
                <main className="flex-1 p-10 bg-white">
                    <div className="modal-content">
                        <div className="question-header">
                            <div className="canLisTxtStyl">
                                <p>Assessment Generator</p>
                            </div>
                        </div>

                        <Form className="p-4" noValidate validated={valiteded}>
                            {/* Difficulty Level Section */}
                            <Form.Group className="mb-3">
                                <Form.Label
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "500",
                                        fontFamily: "Roboto",
                                    }}
                                    className="mainTitleColr"
                                >
                                    Difficulty Level
                                </Form.Label>

                                <div>
                                    {difficultyLevel.map((value) => (
                                        <Form.Check
                                            required
                                            className="mainTitleColr"
                                            style={{
                                                marginBottom: "8px",
                                                fontFamily: "Roboto",
                                                fontWeight: "400",
                                                fontSize: "16px",
                                            }}
                                            key={value.value}
                                            label={value.label}
                                            name="difficulty"
                                            type="radio"
                                            value={value.value}
                                            checked={value.value === details?.difficulty}
                                            onChange={(e) => handleChange("difficulty", e.target.value)}
                                        />
                                    ))}
                                </div>
                            </Form.Group>

                            {/* Number of Questions Section */}
                            <div className="position-relative">
                                <Form.Label
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "500",
                                        fontFamily: "Roboto",
                                        marginTop: "8px",
                                    }}
                                    className="mainTitleColr"
                                >
                                    Select Number of Questions
                                </Form.Label>

                                <div className="position-relative" ref={rangeRef}>
                                    <div
                                        className="value-bubble"
                                        style={{
                                            left: `${thumbLeft}px`,
                                            transform: "translateX(-50%)",
                                        }}
                                    >
                                        {details?.noOfQuestion}
                                    </div>
                                    <input
                                        type="range"
                                        min={MIN}
                                        max={MAX}
                                        value={details?.noOfQuestion}
                                        className="custom-slider"
                                        onChange={(e) => handleChange('noOfQuestion', Number(e.target.value))}
                                    />
                                </div>


                            </div>
                            <div className="d-flex justify-content-between">
                                <small>{MIN}</small>
                                <small>{MAX}</small>
                            </div>


                            {/* Footer Buttons */}
                            <div className="question-modal-footer d-flex justify-content-end">
                                <CustomButton
                                    title="Back"
                                    buttonType="secondary"
                                    handleClick={() => handleNext(3)}
                                />
                                <CustomButton
                                    title="Proceed"
                                    handleClick={() => handleNext(5)}
                                />
                            </div>
                        </Form>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default QuestionOpt;
